module.exports = __webpack_public_path__ + "static/cards-181d0297867564dd48e5f5f44550dbd1.png";